import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  policyWrapper: {
    padding: "0px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    maxWidth: "352px",
    "& h1": {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      color: colors.lightBlack,
      marginBottom: "8px"
    },
    "& p": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: colors.mediumGrey,
      marginBottom: "24px"
    }
  },
  addPolicyBtn: {
    height: "44px"
  },
  logo: {
    marginBottom: "16px",
    "& path": {
      stroke: theme.icon.stroke
    }
  }
}));

export default styles;